const bytecodeDetails = [
  {
    title: "Guía paso a paso para obtener y preparar el Bytecode desde Remix",
    value: `
En esta guía aprenderás a extraer el bytecode de tu contrato Solidity usando Remix, para luego preparar el fragmento necesario para despliegues manuales.

---

### Paso 1: Abre tu contrato  
Selecciona el archivo **RealEstateToken.sol** en el editor de Remix.

![Paso 1](https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/21-1.png)

---

### Paso 2: Compila el contrato  
En el panel de **Solidity Compiler**, asegúrate de que esté seleccionado el contrato correcto y haz clic en **Compile RealEstateToken.sol**.

![Paso 2](https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/21-2.png)

---

### Paso 3: Abre 'Compilation Details'  
Haz clic en el botón **Compilation Details** que aparece en la parte inferior del panel del compilador.

![Paso 3](https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/21-2.png)

---

### Paso 4: Selecciona el contrato correcto en Remix

En Remix, después de compilar, asegúrate de elegir el contrato correcto en el menú desplegable dentro de la pestaña de compilación.  
Esto es importante cuando tu archivo \`.sol\` contiene varios contratos, para que puedas verificar el contrato que realmente desplegaste.

![Paso 4](https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/21-4a.png)

---

### Paso 5: Ve a la sección BYTECODE  
Se abrirá una pestaña con los detalles de compilación. Desplázate hasta encontrar la sección **BYTECODE**.

![Paso 4](https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/21-7.png)

---

### Paso 6: Copia el valor del campo 'object'  
Ubica el campo **object** y copia todo el contenido hexadecimal. Este es tu bytecode.

![Paso 5](https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/21-8.png)
![Paso 5](https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/21-9.png)
---

### Paso 7: Pega el bytecode en un editor  
Abre tu editor de texto preferido (Notepad++, Sublime Text, VSCode) y pega el contenido copiado.

![Paso 6](https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/21-10.png)

---

### Paso 8: Recorta los primeros 40–60 caracteres  
Selecciona desde el primer carácter '6' y copia los primeros 40 a 60 caracteres del bytecode.

![Paso 7](https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/21-11.png)

---

### Paso 9: Agrega el prefijo '0x'  
Agrega el prefijo \`0x\` al inicio del fragmento extraído. Esto es necesario para que el bytecode sea reconocido por herramientas como Etherscan.

![Paso 8](https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/21-12.png)

---

### Paso 9: Guarda el archivo como bytecode-final.txt  
Guarda el archivo con el nombre \`bytecode-final.txt\` para usarlo en despliegues manuales.

![Paso 9](https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/21-12.png)

---

### Paso 10: Verifica que el archivo esté listo  
Revisa que el archivo tenga solo una línea, que comience con \`0x\` y contenga entre 40 y 60 caracteres hexadecimales.

![Paso 10](https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/21-12.png)

---

> **Nota:**  
Este proceso es ideal para pruebas educativas, despliegues manuales y entender cómo funciona el bytecode. Para ambientes productivos, se recomienda usar el bytecode completo y herramientas especializadas como **Hardhat** o **Truffle** para compilar y desplegar contratos de forma segura y automática.
`
  }
];

export default bytecodeDetails;
